import { Link } from "react-router-dom";
import { formatCurrency } from "../../utils/format";

interface BalanceCardProps {
  balance: number;
  currency?: string;
  alertThreshold?: number;
}

function getBalanceColour(balance: number, threshold?: number): string {
  if (threshold && balance <= threshold) return "bg-red-50 border-red-200";
  if (balance < 5000) return "bg-amber-50 border-amber-200"; // < £50
  return "bg-green-50 border-green-200";
}

function getBalanceTextColour(balance: number, threshold?: number): string {
  if (threshold && balance <= threshold) return "text-red-700";
  if (balance < 5000) return "text-amber-700";
  return "text-green-700";
}

export default function BalanceCard({
  balance,
  currency = "GBP",
  alertThreshold,
}: BalanceCardProps) {
  const bgColour = getBalanceColour(balance, alertThreshold);
  const textColour = getBalanceTextColour(balance, alertThreshold);

  return (
    <div className={`rounded-xl border-2 p-6 ${bgColour}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">Account Balance</p>
          <p className={`mt-1 text-3xl font-bold ${textColour}`}>
            {formatCurrency(balance, currency)}
          </p>
          {alertThreshold && balance <= alertThreshold && (
            <p className="mt-1 text-sm text-red-600">
              Below alert threshold ({formatCurrency(alertThreshold, currency)})
            </p>
          )}
        </div>
        <Link
          to="/topup"
          className="rounded-lg bg-simsy-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-simsy-700 focus:outline-none focus:ring-2 focus:ring-simsy-500 focus:ring-offset-2"
        >
          Top Up
        </Link>
      </div>
    </div>
  );
}
